export function ModalThinButtonsBar({ className = '', children }) {
  return (
    <div
      className={`
      flex justify-between items-end max-md:w-full
      bg-white border-t border-slate-300
      pt-3 pb-8 px-4
      ${className}
      `}
    >
      {children}
    </div>
  );
}
